export default {
  // Main navigation
  home: 'Hem',
  back: 'Tillbaka',
  next: 'Nästa',
  previous: 'Föregående',
  start: 'Starta',
  continue: 'Fortsätt',
  finish: 'Avsluta',
  skip: 'Hoppa över',
  cancel: 'Avbryt',
  close: 'Stäng',
  save: 'Spara',
  select: 'Välj',
  edit: 'Redigera',
  delete: 'Radera',
  logout: 'Logga ut',
  settings: 'Inställningar',
  
  // Page titles
  overview: 'Översikt',
  myWork: 'Mitt arbete',
  mySchool: 'Min skolgång',
  myLifestyle: 'Min livsstil',
  myGoals: 'Mina mål',
  myLifestylePlan: 'Min livsstilsplan',
  results: 'Resultat',
  plan: 'Plan',
  
  // Button labels
  getStarted: 'Kom igång',
  startOver: 'Börja om',
  viewResults: 'Visa resultat',
  createPlan: 'Skapa plan',
  loadPlan: 'Ladda plan',
  newPlan: 'Ny plan',
  previousProfiles: 'Tidigare profiler',
  
  // Loading states
  loading: 'Laddar...',
  loadingQuestions: 'Laddar frågor...',
  loadingPlan: 'Laddar plan...',
  saving: 'Sparar...',
  processing: 'Bearbetar...',
  
  // Error messages
  errorOccurred: 'Ett fel uppstod',
  tryAgain: 'Försök igen',
  contactSupport: 'Kontakta support om problemet kvarstår',
  networkError: 'Nätverksfel',
  serverError: 'Serverfel',
  
  // Success messages
  savedSuccessfully: 'Sparat framgångsrikt',
  planCreated: 'Plan skapad framgångsrikt',
  changesSaved: 'Ändringar sparade',
  
  // Form labels
  email: 'E-post',
  password: 'Lösenord',
  confirmPassword: 'Bekräfta lösenord',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  company: 'Företag',
  
  // Validation messages
  required: 'Detta fält är obligatoriskt',
  invalidEmail: 'Ange en giltig e-postadress',
  passwordTooShort: 'Lösenordet måste vara minst 6 tecken',
  passwordsDoNotMatch: 'Lösenorden matchar inte',
  
  // Help text
  help: 'Hjälp',
  instructions: 'Instruktioner',
  tips: 'Tips',
  moreInfo: 'Mer information',
  
  // Modal titles
  confirmAction: 'Bekräfta åtgärd',
  warning: 'Varning',
  information: 'Information',
  success: 'Framgång',
  ok: 'OK',
  
  // Time and dates
  today: 'Idag',
  yesterday: 'Igår',
  thisWeek: 'Denna vecka',
  thisMonth: 'Denna månad',
  lastMonth: 'Förra månaden',
  
  // Progress indicators
  step: 'Steg',
  of: 'av',
  progress: 'Framsteg',
  progressCompleted: 'Slutförd',
  remaining: 'Återstående',
  
  // Status messages
  notStarted: 'Inte påbörjad',
  inProgress: 'Pågående',
  statusCompleted: 'Slutförd',
  pending: 'Väntande',
  active: 'Aktiv',
  inactive: 'Inaktiv'
}; 